document.addEventListener("DOMContentLoaded", function () {
          let infScroll;
          
           const paginationLinks = document.querySelectorAll('.pagination__next');
          paginationLinks.forEach(link => {
              link.href = link.href.replace(/&phcursor=[^&]*/, ''); // Elimina phcursor de la URL
          });
          
          /**
          * Initialize Infinite Scroll (v4).
          */
          const initializeInfiniteScroll = () => {
            // Destroy the old instance if it exists
            if (infScroll && infScroll.destroy) {
              infScroll.destroy();
            }
        
            // Create new Infinite Scroll instance
            infScroll = new InfiniteScroll('.infiniteloop', {
              // SELECTORS
              path: '.pagination__next',        // link to next page
              append: '.loopload',              // items to append
              status: '.page-load-status',      // status element
              // The 'hideNav' option was in v3. In v4, do it manually:
              // e.g., document.querySelector('.pagination').style.display = 'none'
        
              // OPTIONS
              scrollThreshold: 300,             // how close to bottom before loading
              history: false,                   // disable or use 'push' or 'replace'
              // ^ 'back' from v3 is not available in v4
            });
        
            // Hide the nav if desired
            const paginationEl = document.querySelector('.pagination');
            if (paginationEl) {
              paginationEl.style.display = 'none';
            }
        
            // ---- EVENTS ----
            // v3: 'last.infiniteScroll' => v4: 'last'
            infScroll.on('last', () => {
              console.log('No more pages to load.');
              const statusEl = document.querySelector('.page-load-status');
              if (statusEl) {
                statusEl.style.display = 'none';
              }
            });
        
            // v3: 'error.infiniteScroll' => v4: 'error'
            infScroll.on('error', () => {
              console.log('Error loading next page.');
              const statusEl = document.querySelector('.page-load-status');
              if (statusEl) {
                statusEl.style.display = 'none';
              }
            });
        
            // v3: 'load.infiniteScroll' => v4: 'load'
            // In v4, the event callback receives (body, path), not (event, response).
            infScroll.on('load', (body, path) => {
              console.log('Page loaded from path:', path);
              // Hide status if no further .pagination__next link
              if (!document.querySelector('.pagination__next')) {
                const statusEl = document.querySelector('.page-load-status');
                if (statusEl) {
                  statusEl.style.display = 'none';
                }
              }
            });
        
            console.log('Infinite Scroll v4 initialized');
          };
        
          /**
          * Scroll smoothly to a specific product element, then remove the saved ID.
          */
          const scrollToProduct = (productEl) => {
            const topPosition = productEl.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: topPosition, behavior: 'smooth' });
            sessionStorage.removeItem('lastClickedProductId');
          };
        
          /**
          * Repeatedly load next pages until we find the product with lastClickedProductId.
          */
          const loadPagesUntilFound = () => {
            const lastClickedProductId = sessionStorage.getItem('lastClickedProductId');
            if (!lastClickedProductId) return;
        
            const product = document.querySelector(`[data-product-id="${lastClickedProductId}"]`);
            if (product) {
              console.log('Producto encontrado:', product);
              scrollToProduct(product);
            } else if (!document.querySelector('.pagination__next')) {
              console.log('No more pages to load.');
              const statusEl = document.querySelector('.page-load-status');
              if (statusEl) {
                statusEl.style.display = 'none';
              }
            } else {
              console.log('Cargando la siguiente página...');
              // v3: $infiniteloop.infiniteScroll('loadNextPage')
              // v4: infScroll.loadNextPage()
              infScroll.loadNextPage();
              setTimeout(loadPagesUntilFound, 500);
            }
          };
        
          /**
          * Listen for filter changes, reinitialize infinite scroll, and start searching again if needed.
          */
          document.addEventListener('change', (event) => {
            // Check if the event's target or its parent is a .filter-form
            const filterForm = event.target.closest('.filter-form');
            if (filterForm) {
              // Filter changed
              console.log('Filter changed. Reinitializing Infinite Scroll...');
          
              // For example, clear your .infiniteloop container
              const container = document.querySelector('.infiniteloop');
              if (container) {
                container.innerHTML = '';
              }
          
              // Hide status
              const statusEl = document.querySelector('.page-load-status');
              if (statusEl) {
                statusEl.style.display = 'none';
              }
          
              // Re-initialize your Infinite Scroll instance
              initializeInfiniteScroll();
          
              // If you also want to resume looking for a product by ID, do so here
              loadPagesUntilFound();
            }
          });
        
          /**
          * Save product info on click, so we can re-scroll to that item later.
          */
          const container = document.querySelector('.infiniteloop');
          if (container) {
            container.addEventListener('click', (event) => {
              // check if a .grid__item was clicked (or within)
              const item = event.target.closest('.grid__item');
              if (item && item.dataset.productId) {
                sessionStorage.setItem('lastClickedProductId', item.dataset.productId);
                sessionStorage.setItem('scrollPosition', window.scrollY);
                 // Guardar la colección actual (ej. desde la URL: /collections/ropa-interior)
                const collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0];
                if (collectionHandle) {
                  sessionStorage.setItem('lastCollectionHandle', collectionHandle);
                }
              }
            });
          }
        
          // INITIAL SETUP
          initializeInfiniteScroll();
        
          // If we had a stored product ID, try loading pages until we find it
          const currentCollectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0];
          const storedCollectionHandle = sessionStorage.getItem('lastCollectionHandle');

          if (
            sessionStorage.getItem('lastClickedProductId') &&
            currentCollectionHandle &&
            storedCollectionHandle === currentCollectionHandle
          ) {
            loadPagesUntilFound();
          } else {
            // Limpiar si es otra colección
            sessionStorage.removeItem('lastClickedProductId');
            sessionStorage.removeItem('scrollPosition');
            sessionStorage.removeItem('lastCollectionHandle');
          }
        
          // If fewer than 28 products on the initial page, hide the status element
          if (document.querySelectorAll('.loopload').length <= 28) {
            const statusEl = document.querySelector('.page-load-status');
            if (statusEl) {
              statusEl.style.display = 'none';
            }
          }
        });